import { connectHook } from 'app/common/components/connect-hook';
import { BooleanWidget } from './boolean-widget.js';
import { useBooleanWidget } from './boolean-widget-hook.js';

export default connectHook(BooleanWidget, useBooleanWidget);
